export class Session {
    name = '';
    tags: any = {};
    serviceId: string;
    token: string;
    type: string;
    servicePolicies: any[];
    identityId: string;
    service: any;
    edgeRouters: any[];
    apiSessionId: string;
    apiSession: any;
    updatedAt: any;
    createdAt: any;
    id: string;
}
